module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_toMCRichards_LanternExtract_1cover_c1962.f68d9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_toMCRichards_LanternExtract_1cover_c1962.jpg
// module id = 04wK
// module chunks = 0